import React from 'react'
import SecondLayout from "../layouts/SecondLayout";

const Page404 = () => {
  return (
    <SecondLayout>
       <div className="not-found-container">
      <img
        src="/assets/images/img404.jpg" // replace with your actual path
        alt="404 Error"
        className="not-found-image"
      />
      <h2 className="not-found-message">
        We are sorry, the page you've requested is not available.
      </h2>
      <a href="/" className="not-found-button">
        Back to Home
      </a>
    </div>
    </SecondLayout>
  )
}

export default Page404